import { render, staticRenderFns } from "./MenuRelatorios.vue?vue&type=template&id=9699df16&scoped=true"
import script from "./MenuRelatorios.vue?vue&type=script&lang=js"
export * from "./MenuRelatorios.vue?vue&type=script&lang=js"
import style0 from "./MenuRelatorios.vue?vue&type=style&index=0&id=9699df16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9699df16",
  null
  
)

export default component.exports